import { Evaluatie } from "@/entities/evaluatie";
import { PutEvaluatieDetailsDto } from "@/shared/types";

export function buildEvaluatiePayload(evaluatie: Evaluatie | null, patch: Partial<PutEvaluatieDetailsDto>): PutEvaluatieDetailsDto {
    return {
        geenVsmToegedeeld: patch.geenVsmToegedeeld ?? evaluatie?.geenVsmToegedeeld ?? false,
        heeftKhrStatus: patch.heeftKhrStatus ?? evaluatie?.heeftKhrStatus ?? false,
        icDocLink: patch.icDocLink ?? evaluatie?.icDocLink,
        ingezetteMiddelen: patch.ingezetteMiddelen ?? evaluatie?.ingezetteMiddelen ?? {},
        evaluatiePunten: patch.evaluatiePunten ?? evaluatie?.evaluatiePunten ?? {},
        busInzet: patch.busInzet ?? evaluatie?.busInzet ?? {},
    };
}
